export default __webpack_public_path__ + "static/media/photo 9.8c72e5ef.jpg";